import React from "react";
import { Navigate } from "react-router-dom";
import {
  hasPermission,
  isSuperAdmin,
  firstAllowedRoute,
} from "../Utilities/permissions";

// Guards a route by RBAC. Renders `children` only when the current user is
// allowed; otherwise redirects to the first route they can access.
//
// Props:
//   permission  - permission key required (admins need it in their permissions)
//   superOnly   - when true, only super_admin may access (e.g. User Management)
const PermissionRoute = ({ permission, superOnly = false, children }) => {
  const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));

  if (!userInfo || !userInfo.token) {
    return <Navigate to="/login" replace />;
  }

  const allowed = superOnly
    ? isSuperAdmin(userInfo)
    : hasPermission(userInfo, permission);

  if (!allowed) {
    return <Navigate to={firstAllowedRoute(userInfo)} replace />;
  }

  return children;
};

// Redirects "/" and "/home" to the first route the user may access, so an
// admin without dashboard permission isn't bounced into a forbidden page.
export const HomeRedirect = () => {
  const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
  if (!userInfo || !userInfo.token) {
    return <Navigate to="/login" replace />;
  }
  return <Navigate to={firstAllowedRoute(userInfo)} replace />;
};

export default PermissionRoute;
